import axios from 'axios'

export default {
  acmpolicyList (context, opts) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/acmpolicy', { params: opts })
        .then(({ data }) => {
          context.commit('ACM_POLICY_LIST', data)
          resolve(data)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  // ===========================Socket Updates=====================
  acmpolicyUpdated (context, opts) {
    const id = opts && opts.id ? opts.id : opts
    const populated = opts && opts.populate ? opts.populate : []
    const inList = context.state.list.find((i) => i.id === id)
    if (inList) {
      axios
        .get(`/api/acmpolicy/${id}`, { params: populated })
        .then(({ data }) => {
          if (data.id) {
            data.socketUpdate = true
            context.commit('ACM_POLICY_LIST_UPDATE', data)
          }
        }).catch(() => {})
    }
  },
  acmpolicyDestroyed (context, opts) {
    const id = typeof opts === 'string' ? opts : opts && opts.id ? opts.id : '#'
    const inList = context.state.list.find((i) => i.id === id)
    if (id === context.state.current.id) {
      context.commit('ACM_POLICY_CURRENT', null)
    }
    if (inList) {
      context.commit('ACM_POLICY_LIST_REMOVE', id)
    }
  }
}
